// extracted by mini-css-extract-plugin
module.exports = {"heading":"PasswordScreen_heading__jyD3k","form":"PasswordScreen_form__cUzRD","forgot":"PasswordScreen_forgot__NTeU0","error":"PasswordScreen_error__a3js0"};